import { FormattedMessage } from "react-intl";
import React from "react";

export const selectOpts = [
  {
    value: "true",
    label: (
      <FormattedMessage
        id="sna.sidebar.adjusttool.node.count.show"
        defaultMessage="是"
      />
    ),
  },
  {
    value: "false",
    label: (
      <FormattedMessage
        id="sna.sidebar.adjusttool.node.count.hidden"
        defaultMessage="否"
      />
    ),
  },
];
